import React from 'react'
import styled from 'styled-components'
import { BodyCopy, H6 } from './Typography'
import Button from './Button'
import LocalLink from './LocalLink'
import { StyledButton } from './ButtonStyled'
import { Variables } from '../styles/Variables'
import media from 'css-in-js-media'
import { Col } from 'react-styled-flexboxgrid'
import SocialLink from './SociaLink'

const LinksWrapper = styled.div``

const LinksHeader = styled.div`
    margin-bottom: 20px;

    ${H6} {
        font-family: ${Variables.font.body};
        font-style: normal;
        font-weight: normal;
        font-size: 24px;
        line-height: 34px;
    }
`

const LinkWrap = styled.div`
    margin-bottom: 20px;
    a {
        font-weight: 500;
        font-size: 18px;
        line-height: 22px;
        color: ${Variables.color.white};        
        font-family: ${Variables.font.body};
        ${media('<desktop')} {
            font-size: 16px;
            line-height: 20px;
        }
    }
`

const FooterColumnCopy = styled.div`
    ${BodyCopy} {        
        color: ${Variables.color.white};
        font-weight: 500;
        font-size: 18px;
        line-height: 22px;
        ${media('<desktop')} {
            font-size: 16px;
            line-height: 20px;
        }
    }
`
const FooterColumnButtons = styled.div`
    margin-top: 20px;

    ${StyledButton} {
        width: auto ;
        min-width: 268px;
        font-size: 12px;         
        margin: 10px 0;  
        border-color: ${Variables.color.white};
        &:before {
            border-color: ${Variables.color.white} !important;
        }
        &:hover {
            background-color: ${Variables.color.pazolaGold};
            border-color: ${Variables.color.pazolaGold};
            color: ${Variables.color.white};
            &:before {
                border-color: ${Variables.color.white} !important;
            }
        }

        ${media('<desktop')} {
            min-width: 208px ;
        }
    }
`

const LinksColumn = styled(Col)``;

const SocialWrapper = styled.div`
    ${media('<desktop')} {
        padding-bottom: 43px;
        padding-top: 43px;
    }
`;

const FooterColumn: React.FC = ({ footerColumn, noTitle }) => {
    let columnWidth = 3;
    let xsColumnWidth = 12;
    if (footerColumn.links && footerColumn.title != "social") {
        columnWidth = 2;  
        xsColumnWidth = 6;      
    }
    if (footerColumn.title == "social") {
        columnWidth = 5;
        xsColumnWidth = 12;
    }

    return (
        <LinksColumn xs={xsColumnWidth} sm={columnWidth}>
            {/* {!noTitle && (
                <LinksHeader>
                    <H6>{footerColumn.title}</H6>
                </LinksHeader>
            )} */}

            {footerColumn.subtitle && (
                <FooterColumnCopy>
                    <BodyCopy
                        dangerouslySetInnerHTML={{
                            __html: footerColumn.subtitle.childMarkdownRemark.html,
                        }}
                    />
                </FooterColumnCopy>
            )}
            {footerColumn.links && footerColumn.title != 'social' && (
                <LinksWrapper>
                    {footerColumn.links.map((link, i) => (
                        <LinkWrap key={i}>
                            {link.externalLink ? (
                                <a href={link.externalLink} target="_blank">
                                    {link.name}
                                </a>
                            ) : (
                                <LocalLink to={link.internalLink.slug}>{link.internalLink.title}</LocalLink>
                            )}
                        </LinkWrap>
                    ))}
                </LinksWrapper>
            )}
            {footerColumn.title == 'social' && (
                <SocialWrapper>
                    {footerColumn.links.map((socialLink, i) => (
                        <SocialLink socialLink={socialLink} key={i} />
                    ))}
                </SocialWrapper>
            )}
            {footerColumn.buttons && (
                <FooterColumnButtons>
                    {footerColumn.buttons.map((button, i) => (
                        <Button key={i} buttonLink={button.buttonLink} secondary full textalign="center">
                            {button.text}
                        </Button>
                    ))}
                </FooterColumnButtons>
            )}
        </LinksColumn>
    )
}

export default FooterColumn
